// extracted by mini-css-extract-plugin
export default {"Toast":"Toast_Toast__j-CKI","title":"Toast_title__kpC4S","detail":"Toast_detail__cRwX3","ToastHost":"Toast_ToastHost__TBgyZ"};